<template>
<div class="col-md-4">
    <section class="card">
        <table class="table">
            <tbody>
            <tr>
                <th>{{ t.stats.extended.has_children }}</th>
                <td>
                    <editable :params="personParams" :options="childrenHaveOptions" property="childrenHave" type="select"
                        :value="person.childrenHave" :editable="editMode"></editable>
                </td>
            </tr>
            <tr>
                <th>{{ t.stats.extended.wants_children }}</th>
                <td>
                    <editable :params="personParams" :options="childrenLikeOptions" property="childrenLike" type="select"
                        :value="person.childrenLike" :editable="editMode"></editable>
                </td>
            </tr>
            <tr>
                <th>{{ t.stats.extended.employment }}</th>
                <td>
                    <editable :params="personParams" :options="employmentOptions" property="employment" type="select"
                        :value="person.employment" :editable="editMode"></editable>
                </td>
            </tr>
            <tr>
                <th>{{ t.stats.extended.hair }}</th>
                <td>
                    <editable :params="personParams" :options="hairOptions" property="hair" type="select"
                        :value="person.hair" :editable="editMode"></editable>
                </td>
            </tr>
            <tr>
                <th>{{ t.stats.extended.hair_colour }}</th>
                <td>
                    <editable :params="personParams" :options="hairColourOptions" property="hairColour" type="select"
                        value="person.hairColour" :editable="editMode"></editable>
                </td>
            </tr>
            <tr>
                <th>{{ t.stats.extended.materialistic }}</th>
                <td>
                    <editable :params="personParams" :options="materialisticOptions" property="materialistic" type="select"
                        :value="person.materialistic" :editable="editMode"></editable>
                </td>
            </tr>
            <tr>
                <th>{{ t.stats.extended.personality }}</th>
                <td>
                    <editable :params="personParams" :options="personalityOptions" property="personality" type="select"
                        :value="person.personality" :editable="editMode"></editable>
                </td>
            </tr>
            <tr>
                <th>{{ t.stats.extended.relationship }}</th>
                <td>
                    <editable :params="personParams" :options="relationshipOptions" property="relationship" type="select"
                        :value="person.relationship" :editable="editMode"></editable>
                </td>
            </tr>
            <tr>
                <th>{{ t.stats.extended.religion }}</th>
                <td>
                    <editable :params="personParams" :options="religionOptions" property="religion" type="select"
                        :value="person.religion" :editable="editMode"></editable>
                </td>
            </tr>
            <tr>
                <th>{{ t.stats.extended.social_class }}</th>
                <td>
                    <editable :params="personParams" :options="socialClassOptions" property="socialClass" type="select"
                        :value="person.socialClass" :editable="editMode"></editable>
                </td>
            </tr>
            <tr>
                <th>{{ t.stats.extended.transport }}</th>
                <td>
                    <editable :params="personParams" :options="transportOptions" property="transport" type="checkboxes"
                        :value="profile.transport" :editable="editMode"></editable>
                </td>
            </tr>
            </tbody>
        </table>
    </section>
</div>
</template>

<script>
import Editable from 'Site/component/Editable.vue';
import { mapState } from 'vuex';

export default {
    name: 'ProfileStatsExtended',
    components: {
        Editable
    },
    computed: {
        ...mapState({
            config: state => state.config.data
        }),
        person() {
            return this.profile.persons[0];
        },
        personParams() {
            return { url: 'person', id: this.config.persons[0] };
        }
    },
    data() {
        return {
            childrenHaveOptions: this.localConfig.data.formOptions.childrenHave,
            childrenLikeOptions: this.localConfig.data.formOptions.childrenLike,
            employmentOptions: this.localConfig.data.formOptions.employment,
            hairOptions: this.localConfig.data.formOptions.hair,
            hairColourOptions: this.localConfig.data.formOptions.hairColour,
            materialisticOptions: this.localConfig.data.formOptions.materialistic,
            personalityOptions: this.localConfig.data.formOptions.personality,
            relationshipOptions: this.localConfig.data.formOptions.relationship,
            religionOptions: this.localConfig.data.formOptions.religion,
            socialClassOptions: this.localConfig.data.formOptions.socialClass,
            transportOptions: this.localConfig.data.formOptions.transport
        };
    },
    props: {
        editMode: {
            type: Boolean,
            default: false
        },
        localConfig: {
            type: Object,
            required: true
        },
        profile: {
            type: Object,
            required: true
        },
        t: {
            type: Object,
            required: true
        }
    }
};

</script>
